import { kind as start } from '../../actions/goals/Start';
import { kind as stopKind } from '../../actions/goals/Stop';
import { reject, rejectAll, resolve } from '../../GoalResolvers';
import { State } from '../../State';
import { idle } from './idle';
import { suspend } from './suspend';

export function stop(state: State): State {
  const reason = 'Stopping';
  let goalResolvers = state.goalResolvers;
  goalResolvers = reject(goalResolvers, start, reason);

  if (state.replication) {
    return suspend({ ...state, goalResolvers });
  }

  goalResolvers = resolve(goalResolvers, stopKind);
  goalResolvers = rejectAll(goalResolvers, reason);

  return idle({ ...state, goalResolvers });
}
